export default "__VITE_ASSET__fee2b183__"